import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { ApolloProvider as BaseApolloProvider } from '@apollo/client/react';
import { ReactNode, useMemo } from 'react';

import { useAppConfig } from './app-config-provider';

// Create Apollo Client with dynamic URL
function createApolloClient(graphqlUrl: string) {
  const httpLink = createHttpLink({
    uri: graphqlUrl,
  });

  // Add authentication header
  const authLink = setContext((_, { headers }) => {
    // Get the user email from localStorage
    const userEmail = localStorage.getItem('userEmail');

    return {
      headers: {
        ...headers,
        ...(userEmail && { 'x-oap-user-email': userEmail }),
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
}

interface ApolloProviderProps {
  children: ReactNode;
}

export function ApolloProvider({ children }: ApolloProviderProps) {
  const { config } = useAppConfig();
  const client = useMemo(
    () => createApolloClient(config.graphqlUrl),
    [config.graphqlUrl],
  );

  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
}
